import { render, staticRenderFns } from "./BusinessRevenueReport.vue?vue&type=template&id=0ca296fb&scoped=true"
import script from "./BusinessRevenueReport.vue?vue&type=script&lang=js"
export * from "./BusinessRevenueReport.vue?vue&type=script&lang=js"
import style0 from "./BusinessRevenueReport.vue?vue&type=style&index=0&id=0ca296fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca296fb",
  null
  
)

export default component.exports